import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  max-width: 940px;
  text-align: start;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 40px 0 24px 0;
`;

export const Title = styled.h1`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.medium};
    text-align: center;
  `};
`;

export const NavWrapper = styled.div`
  display: inline-block;
  margin-bottom: 28px;
  width: 100%;
`;

export const Description = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xs};
  `};
`;

export const NavbarContainer = styled.div`
  ${({ theme }) => css`
    align-items: end;
    background: ${theme.v2.colors.neutral.highLight};
    border-radius: 8px 8px 0px 0px;
    display: flex;
    padding-top: 8px;
    width: 100%;
  `};
`;

export const NavbarImage = styled.img`
  height: 32px;
  user-select: none;
  -webkit-user-drag: none;
`;

export const DomainForm = styled.form`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 10px;
    background: ${theme.v2.colors.white.primary};
    border-radius: 0px 0px 8px 8px;
    min-height: 78px;
    padding: 18px 24px;
  `};
`;

export const DomainFieldsContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: 8px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      flex-direction: column;
    }
  `};
`;

export const ButtonWrapper = styled.div`
  height: 48px;
  width: 52px;
`;

export const Offer = styled.p`
  ${({ theme }) => css`
    margin: 0;
    size: 16px;

    .freeDomain {
      color: ${theme.v2.colors.feedback.activePure};
    }
  `};
`;
